<script>
  import PatentesService from '../../../../../domain/policia-civil/patentes/services/patentes'
  import { isArray } from 'lodash'

  export default {
    components: {},
    nome: 'nova-patente',
    data () {
      return {
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        data: {
          id: null,
          nome: null,
          ativo: false
        }
      }
    },
    computed: {
    },
    created () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        if (this.$route.params.id) {
          this.$loaderOverlay.open().message('Carregando')
          PatentesService.find(this.$route.params.id)
            .then((response) => {
              this.isLoaded = true
              this.$loaderOverlay.hide()
              this.data = response.data
              console.log(response)
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
          this.isLoaded = true
          // this.$loaderOverlay.open().message('Aguarde')
        }
      },
      submit () {
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando...')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        PatentesService.cadastrar(this.data, this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
              this.atualizadoSucesso = true
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Patente</h1></div>
          <div class="col-sm-6">
            <router-link :to="{name: 'config.patente.list'}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
            </router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-4 control-label">Nome</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.nome"/>
                </div>
              </div>

              <div class="form-group">
                <label for="tipo-impeditiva" class="col-sm-4 control-label">Ativo</label>
                <div class="col-sm-8">
                  <input id="tipo-impeditiva" type="checkbox" v-model="data.ativo"/>
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$router.push({name: 'config.patentes.list'})">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// NovaPatente.vue?23f81432